import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { Spinner } from "@causetide/ui";
import { useAuth } from "./auth.js";
const Shell = lazy(() => import("./components/Shell.js").then(module => ({ default: module.Shell })));
const LoginPage = lazy(() => import("./pages/Login.js").then(module => ({ default: module.LoginPage })));
const ForgotPasswordPage = lazy(() => import("./pages/auth/ForgotPasswordPage.js").then(module => ({ default: module.ForgotPasswordPage })));
const ResetPasswordPage = lazy(() => import("./pages/auth/ResetPasswordPage.js").then(module => ({ default: module.ResetPasswordPage })));
const ConstituentsList = lazy(() => import("./pages/ConstituentsList.js").then(module => ({ default: module.ConstituentsList })));
const ConstituentDetail = lazy(() => import("./pages/ConstituentDetail.js").then(module => ({ default: module.ConstituentDetail })));
const GiftsPage = lazy(() => import("./pages/GiftsPage.js").then(module => ({ default: module.GiftsPage })));
const BatchesPage = lazy(() => import("./pages/BatchesPage.js").then(module => ({ default: module.BatchesPage })));
const BatchEntryPage = lazy(() => import("./pages/BatchEntryPage.js").then(module => ({ default: module.BatchEntryPage })));
const PledgesPage = lazy(() => import("./pages/PledgesPage.js").then(module => ({ default: module.PledgesPage })));
const PlannedGivingPage = lazy(() => import("./pages/PlannedGivingPage.js").then(module => ({ default: module.PlannedGivingPage })));
const RecurringPage = lazy(() => import("./pages/RecurringPage.js").then(module => ({ default: module.RecurringPage })));
const TasksPage = lazy(() => import("./pages/TasksPage.js").then(module => ({ default: module.TasksPage })));
const SegmentsPage = lazy(() => import("./pages/SegmentsPage.js").then(module => ({ default: module.SegmentsPage })));
const PortfolioPage = lazy(() => import("./pages/PortfolioPage.js").then(module => ({ default: module.PortfolioPage })));
const EmailPage = lazy(() => import("./pages/EmailPage.js").then(module => ({ default: module.EmailPage })));
const EmailBuilderPage = lazy(() => import("./pages/EmailBuilderPage.js").then(module => ({ default: module.EmailBuilderPage })));
const AutomationsPage = lazy(() => import("./pages/AutomationsPage.js").then(module => ({ default: module.AutomationsPage })));
const ImportsPage = lazy(() => import("./pages/ImportsPage.js").then(module => ({ default: module.ImportsPage })));
const ReceiptsPage = lazy(() => import("./pages/ReceiptsPage.js").then(module => ({ default: module.ReceiptsPage })));
const ReportsPage = lazy(() => import("./pages/ReportsPage.js").then(module => ({ default: module.ReportsPage })));
const SettingsPage = lazy(() => import("./pages/SettingsPage.js").then(module => ({ default: module.SettingsPage })));
const GivePage = lazy(() => import("./pages/GivePage.js").then(module => ({ default: module.GivePage })));
const EventPublicPage = lazy(() => import("./pages/EventPublicPage.js").then(module => ({ default: module.EventPublicPage })));
const PortalPage = lazy(() => import("./pages/PortalPage.js").then(module => ({ default: module.PortalPage })));
const UpdateCardPage = lazy(() => import("./pages/UpdateCardPage.js").then(module => ({ default: module.UpdateCardPage })));
const EventsPage = lazy(() => import("./pages/EventsPage.js").then(module => ({ default: module.EventsPage })));
const EventDetail = lazy(() => import("./pages/EventDetail.js").then(module => ({ default: module.EventDetail })));
const GrantsPage = lazy(() => import("./pages/GrantsPage.js").then(module => ({ default: module.GrantsPage })));
const GrantDetail = lazy(() => import("./pages/GrantDetail.js").then(module => ({ default: module.GrantDetail })));
const MembershipsPage = lazy(() => import("./pages/MembershipsPage.js").then(module => ({ default: module.MembershipsPage })));
const VolunteersPage = lazy(() => import("./pages/VolunteersPage.js").then(module => ({ default: module.VolunteersPage })));
const VolunteerDetail = lazy(() => import("./pages/VolunteerDetail.js").then(module => ({ default: module.VolunteerDetail })));
const GiftAidPage = lazy(() => import("./pages/GiftAidPage.js").then(module => ({ default: module.GiftAidPage })));
const ScoresPage = lazy(() => import("./pages/ScoresPage.js").then(module => ({ default: module.ScoresPage })));
const TextingPage = lazy(() => import("./pages/TextingPage.js").then(module => ({ default: module.TextingPage })));
const AuctionsPage = lazy(() => import("./pages/AuctionsPage.js").then(module => ({ default: module.AuctionsPage })));
const AuctionDetail = lazy(() => import("./pages/AuctionDetail.js").then(module => ({ default: module.AuctionDetail })));
const AuctionBidPage = lazy(() => import("./pages/AuctionBidPage.js").then(module => ({ default: module.AuctionBidPage })));
const MailPage = lazy(() => import("./pages/MailPage.js").then(module => ({ default: module.MailPage })));
const NcoaPage = lazy(() => import("./pages/NcoaPage.js").then(module => ({ default: module.NcoaPage })));
const LetterTemplatePage = lazy(() => import("./pages/LetterTemplatePage.js").then(module => ({ default: module.LetterTemplatePage })));
const OutreachPage = lazy(() => import("./pages/OutreachPage.js").then(module => ({ default: module.OutreachPage })));
const OperatorPortal = lazy(() => import("./pages/OperatorPortal.js").then(module => ({ default: module.OperatorPortal })));
const DeveloperApplyPage = lazy(() => import("./pages/DeveloperApplyPage.js").then(module => ({ default: module.DeveloperApplyPage })));
const RetentionDashboardPage = lazy(() => import("./pages/RetentionDashboardPage.js").then(module => ({ default: module.RetentionDashboardPage })));
const ReportBuilderPage = lazy(() => import("./pages/ReportBuilderPage.js").then(module => ({ default: module.ReportBuilderPage })));
const DashboardPage = lazy(() => import("./pages/DashboardPage.js").then(module => ({ default: module.DashboardPage })));
const PagesPage = lazy(() => import("./pages/PagesPage.js").then(module => ({ default: module.PagesPage })));
const PageBuilderPage = lazy(() => import("./pages/PageBuilderPage.js").then(module => ({ default: module.PageBuilderPage })));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage.js").then(module => ({ default: module.NotFoundPage })));
const EmbedFormPage = lazy(() => import("./pages/EmbedFormPage.js").then(module => ({ default: module.EmbedFormPage })));
const EmbedWidgetPage = lazy(() => import("./pages/EmbedWidgetPage.js").then(module => ({ default: module.EmbedWidgetPage })));
const VolunteerBoardPage = lazy(() => import("./pages/VolunteerBoardPage.js").then(module => ({ default: module.VolunteerBoardPage })));
const EmbedVolunteerBoardPage = lazy(() => import("./pages/VolunteerBoardPage.js").then(module => ({ default: module.EmbedVolunteerBoardPage })));
const VolunteerSelfPage = lazy(() => import("./pages/VolunteerSelfPage.js").then(module => ({ default: module.VolunteerSelfPage })));
const OAuthConsentPage = lazy(() => import("./pages/OAuthConsentPage.js").then(module => ({ default: module.OAuthConsentPage })));
const DeveloperOAuthDocsPage = lazy(() => import("./pages/DeveloperOAuthDocsPage.js").then(module => ({ default: module.DeveloperOAuthDocsPage })));
const DeveloperApiDocsPage = lazy(() => import("./pages/DeveloperApiDocsPage.js").then(module => ({ default: module.DeveloperApiDocsPage })));
const PublicSlugPage = lazy(() => import("./pages/P2PPublicPage.js").then(module => ({ default: module.PublicSlugPage })));
const P2PFundraiserPage = lazy(() => import("./pages/P2PPublicPage.js").then(module => ({ default: module.P2PFundraiserPage })));
const P2PTeamPage = lazy(() => import("./pages/P2PPublicPage.js").then(module => ({ default: module.P2PTeamPage })));
const EmbedP2PPage = lazy(() => import("./pages/P2PPublicPage.js").then(module => ({ default: module.EmbedP2PPage })));
const P2PManagePage = lazy(() => import("./pages/P2PManagePage.js").then(module => ({ default: module.P2PManagePage })));
const P2PCampaignsPage = lazy(() => import("./pages/P2PCampaignsPage.js").then(module => ({ default: module.P2PCampaignsPage })));
const CustomObjectsIndex = lazy(() => import("./pages/CustomObjectsPage.js").then(module => ({ default: module.CustomObjectsIndex })));
const CustomObjectRecordsPage = lazy(() => import("./pages/CustomObjectsPage.js").then(module => ({ default: module.CustomObjectRecordsPage })));
const CustomObjectRecordPage = lazy(() => import("./pages/CustomObjectsPage.js").then(module => ({ default: module.CustomObjectRecordPage })));
const P2PCampaignDetailPage = lazy(() => import("./pages/P2PCampaignsPage.js").then(module => ({ default: module.P2PCampaignDetailPage })));
import { useLocation } from "react-router";

export function App() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // public, unauthenticated routes (donor pages, password recovery) — never gated behind staff login
  if (
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password" ||
    location.pathname.startsWith("/give/") ||
    location.pathname.startsWith("/portal/") ||
    location.pathname.startsWith("/p/") ||
    location.pathname.startsWith("/embed/") ||
    location.pathname.startsWith("/v/") ||
    location.pathname.startsWith("/bid/") ||
    location.pathname.startsWith("/operator") ||
    location.pathname.startsWith("/developers") ||
    /^\/events\/[^/]+\/[^/]+/.test(location.pathname)
  ) {
    return (
      <Suspense fallback={<div role="status" aria-label="Loading page" className="p-6"><Spinner size={24} /></div>}><Routes>
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/give/:slug" element={<GivePage />} />
        <Route path="/events/:slug/:eventId" element={<EventPublicPage />} />
        <Route path="/portal/:slug" element={<PortalPage />} />
        <Route path="/portal/:slug/update-card" element={<UpdateCardPage />} />
        <Route path="/p/:slug/:pageSlug" element={<PublicSlugPage />} />
        <Route path="/p/:slug/:campaign/manage" element={<P2PManagePage />} />
        <Route path="/p/:slug/:campaign/team/:teamSlug" element={<P2PTeamPage />} />
        <Route path="/p/:slug/:campaign/:pageSlug" element={<P2PFundraiserPage />} />
        <Route path="/embed/p/:slug/:pageSlug" element={<EmbedFormPage />} />
        <Route path="/embed/w/:slug/:pageSlug/:kind" element={<EmbedWidgetPage />} />
        <Route path="/embed/v/:slug" element={<EmbedVolunteerBoardPage />} />
        <Route path="/embed/f/:slug/:campaign" element={<EmbedP2PPage />} />
        <Route path="/embed/f/:slug/:campaign/:pageSlug" element={<EmbedP2PPage />} />
        <Route path="/v/:slug" element={<VolunteerBoardPage />} />
        <Route path="/v/:slug/me" element={<VolunteerSelfPage />} />
        <Route path="/bid/:slug/:auctionId" element={<AuctionBidPage />} />
        <Route path="/operator" element={<OperatorPortal />} />
        <Route path="/developers" element={<DeveloperApplyPage />} />
        <Route path="/developers/oauth" element={<DeveloperOAuthDocsPage />} />
        <Route path="/developers/api" element={<DeveloperApiDocsPage />} />
        {/* e.g. /give/ with no slug, /operator/typo: say so instead of rendering a blank page */}
        <Route path="*" element={<NotFoundPage homeHref="/" homeLabel="Go to CauseTide" />} />
      </Routes></Suspense>
    );
  }

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-[var(--color-text-tertiary)]">
        <Spinner size={24} />
      </div>
    );
  }

  if (!user) {
    return (
      <Suspense fallback={<div role="status" aria-label="Loading page" className="p-6"><Spinner size={24} /></div>}><Routes>
        <Route path="*" element={<LoginPage />} />
      </Routes></Suspense>
    );
  }

  return (
    <Suspense fallback={<div role="status" aria-label="Loading page" className="p-6"><Spinner size={24} /></div>}><Routes>
      {/* CT-RM-19 consent screen: signed-in, but outside the app chrome */}
      <Route path="/oauth/authorize" element={<OAuthConsentPage />} />
      <Route element={<Shell />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/constituents" element={<ConstituentsList />} />
        <Route path="/constituents/:id" element={<ConstituentDetail />} />
        <Route path="/gifts" element={<GiftsPage />} />
        <Route path="/batches" element={<BatchesPage />} />
        <Route path="/batches/:id" element={<BatchEntryPage />} />
        <Route path="/pledges" element={<PledgesPage />} />
        <Route path="/planned-giving" element={<PlannedGivingPage />} />
        <Route path="/recurring" element={<RecurringPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/grants" element={<GrantsPage />} />
        <Route path="/grants/:id" element={<GrantDetail />} />
        <Route path="/memberships" element={<MembershipsPage />} />
        <Route path="/p2p" element={<P2PCampaignsPage />} />
        <Route path="/p2p/:id" element={<P2PCampaignDetailPage />} />
        {/* CT-RM-34: custom objects */}
        <Route path="/objects" element={<CustomObjectsIndex />} />
        <Route path="/objects/:typeKey" element={<CustomObjectRecordsPage />} />
        <Route path="/objects/:typeKey/:recordId" element={<CustomObjectRecordPage />} />
        <Route path="/volunteers" element={<VolunteersPage />} />
        <Route path="/volunteers/:id" element={<VolunteerDetail />} />
        <Route path="/gift-aid" element={<GiftAidPage />} />
        <Route path="/scores" element={<ScoresPage />} />
        <Route path="/outreach" element={<OutreachPage />} />
        <Route path="/texting" element={<TextingPage />} />
        <Route path="/auctions" element={<AuctionsPage />} />
        <Route path="/auctions/:id" element={<AuctionDetail />} />
        <Route path="/mail" element={<MailPage />} />
        <Route path="/mail/templates/:id" element={<LetterTemplatePage />} />
        <Route path="/mail/ncoa" element={<NcoaPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/segments" element={<SegmentsPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/pages" element={<PagesPage />} />
        <Route path="/pages/builder" element={<PageBuilderPage />} />
        <Route path="/email" element={<EmailPage />} />
        <Route path="/email/builder" element={<EmailBuilderPage />} />
        <Route path="/automations" element={<AutomationsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/imports" element={<ImportsPage />} />
        <Route path="/receipts" element={<ReceiptsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/builder" element={<ReportBuilderPage />} />
        <Route path="/reports/retention" element={<RetentionDashboardPage />} />
        <Route path="/settings/*" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes></Suspense>
  );
}
